import { t } from 'i18next';
import * as yup from 'yup';

import { numberSchemaWithTransform } from 'core/yup';

export const copyMoveToElementSchema = () =>
  yup.object().shape({
    element: yup
      .object()
      .shape({
        id: numberSchemaWithTransform().nullable(),
        name: yup.string().label(t('labelElement')).nullable().required(),
      })
      .label(t('labelElement'))
      .nullable()
      .required(),
    componentData: yup
      .array()
      .of(
        yup
          .object()
          .shape({
            id: numberSchemaWithTransform().nullable(),
            quantity: numberSchemaWithTransform()
              .label(t('labelQuantity'))
              .nullable()
              .when('isValid', {
                is: true,
                then: numberSchemaWithTransform().min(0).required(),
                otherwise: numberSchemaWithTransform().nullable(),
              }),
            isValid: yup.boolean().nullable(),
          })
          .nullable()
      )
      .nullable(),
  });
